import { useEffect, useState, type ReactNode } from "react";
import { hasStoredSession } from "@/lib/has-stored-session";

/**
 * Renders children only when they can actually do something:
 * - αμέσως (μετά το hydration) αν υπάρχει αποθηκευμένη συνεδρία,
 * - αλλιώς μόνο μετά την πρώτη αλληλεπίδραση του επισκέπτη.
 *
 * Τα CartSync/WishlistSync/PandaGameModal τραβούν το chunk του Supabase
 * (~53 KiB). Για ανώνυμους επισκέπτες είναι εντελώς αχρησιμοποίητο, οπότε δεν
 * κατεβαίνει καθόλου στην αρχική φόρτωση.
 */
export function SessionGatedMount({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (hasStoredSession()) {
      setReady(true);
      return;
    }
    const events = ["pointerdown", "keydown", "touchstart", "scroll"] as const;
    const on = () => setReady(true);
    for (const e of events) window.addEventListener(e, on, { once: true, passive: true });
    return () => {
      for (const e of events) window.removeEventListener(e, on);
    };
  }, []);

  if (!ready) return null;
  return <>{children}</>;
}
